import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import ArtifactAgentAvatar from "./ArtifactAgentAvatar";

interface Props {
  onCollapse: () => void;
}

const ArtifactAgentHeader = ({ onCollapse }: Props) => (
  <Stack direction="row" spacing={1.25} sx={{ alignItems: "center", pl: 2, pr: 1.25, py: 1.5 }}>
    <ArtifactAgentAvatar size="medium" />
    <Typography variant="h6" sx={{ flex: 1 }}>
      AI Assistant
    </Typography>
    <Tooltip title="Collapse">
      <IconButton aria-label="Collapse the assistant" onClick={onCollapse}>
        <KeyboardArrowRightRoundedIcon />
      </IconButton>
    </Tooltip>
  </Stack>
);

export default ArtifactAgentHeader;
